import { LoadState } from "../../constants/enums";
import {
	ICompanyOutletAddress,
	ICompanyOutletAddressState,
} from "./companyOutletAddress.types";

export const initialCompanyOutletAddress: ICompanyOutletAddress = {
	company_outlet_address_uuid: "",
	company_outlet_uuid: null,
	company_outlet_name: "",
	delivery_name: null,
	company_outlet_address_line1: null,
	company_outlet_address_line2: null,
	company_outlet_address_city: null,
	company_outlet_address_state: null,
	company_outlet_address_pincode: null,
	company_outlet_address_country: null,
	status: "ACTIVE",
};
export const initialCompanyOutletAddressState: ICompanyOutletAddressState = {
	list: {
		list: [],
		totalRecords: 0,
		loading: LoadState.NotLoaded,
		error: null,
	},
	companyOutletAddress: {
		data: initialCompanyOutletAddress,
		loading: LoadState.NotLoaded,
		error: null,
	},
};
